<template>
  <div>
    <div class="display-flex w-100 justify-content-between">
      <h2 class="mb-0">Nazwy voucherów</h2>
      <v-btn color="#555474" class="mt-0 mb-0 mr-0 ml-3" @click="addType = true" dark>
        <v-icon size="15px" class="icon-btn">fas fa-plus</v-icon>&nbsp;Dodaj nazwa vouchera
      </v-btn>
    </div>
    <div class="mt-4 content-wrapper p-3">
      <v-data-table
        :headers="getHeaders"
        :items="getVouchersTypeList"
        :pagination.sync="paginationData"
        sort-icon="fa-arrow-down" class="elevation-1 main-table"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="text-xs-center">
            <div>
              <v-btn small color="#555474" @click="editType = true; selectedRow = props.item" dark>Edytuj</v-btn>
              <v-btn small color="default" @click="deleteType = true; selectedRow = props.item" class="mr-0">Usuń
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
    <CreateVoucherTypes
      :open="addType"
      @close="fetchVoucherTypes(); addType = false">
    </CreateVoucherTypes>
    <EditVoucherType
      :open="editType"
      :form-data="Object.assign({}, selectedRow)"
      @close="fetchVoucherTypes(); editType = false; selectedRow = {}">
    </EditVoucherType>
    <DeleteModal
      :open="deleteType"
      deleteText="Czy na pewno chcesz usunąć nazwę vouchera?"
      @close="deleteType = false"
      @accept="removeVoucherType(selectedRow.id); deleteType = false; selectedRow = {}"
    ></DeleteModal>

  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import CreateVoucherTypes from '../components/VoucherTypes/CreateVoucherType.vue';
  import EditVoucherType from '../components/VoucherTypes/EditVoucherType.vue';
  import DeleteModal from '../components/Globals/ModalDelete.vue';

  export default {
    name: 'VoucherTypes',
    components: {
      CreateVoucherTypes,
      EditVoucherType,
      DeleteModal,
    },
    data() {
      return {
        addType: false,
        editType: false,
        deleteType: false,
        loading: true,
        selectedRow: {},
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
        },
      };
    },
    computed: {
      ...mapGetters('VoucherTypeStore', ['getHeaders', 'getVouchersTypeList']),
    },
    beforeMount() {
      this.fetchVoucherTypes()
        .then(() => {
          this.loading = false;
        });
    },
    methods: {
      ...mapActions('VoucherTypeStore', ['fetchVoucherTypes', 'removeVoucherType']),
    },
  };
</script>

<style scoped>

</style>
